import script from "./historicalRecord.vue?vue&type=script&setup=true&lang=js"
export * from "./historicalRecord.vue?vue&type=script&setup=true&lang=js"

import "./historicalRecord.vue?vue&type=style&index=0&id=e9d8e842&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e9d8e842"]])

export default __exports__